<form [formGroup]="form">
  <usucampeao-select controlName="usage" label="Uso do domicílio*" [disabled]="readonly">
    <ion-select-option *ngFor="let uso of imovelUsos" [value]="uso">{{ uso | imovelUso }}</ion-select-option>

    <span usu-error>{{ gerarMensagemErro('usage') }}</span>
  </usucampeao-select>

  <usucampeao-select controlName="occupation" label="Caráter da ocupação*" [disabled]="readonly">
    <ion-select-option *ngFor="let ocupacao of imovelOcupacoes" [value]="ocupacao">{{ ocupacao | imovelOcupacao }}</ion-select-option>

    <span usu-error>{{ gerarMensagemErro('occupation') }}</span>
  </usucampeao-select>

  <usucampeao-input controlName="loteArea" type="tel" label="Área do terreno ou lote" mask="000000000" [readonly]="readonly">
    <span usu-suffix>m²</span>

    <span usu-error>{{ gerarMensagemErro('loteArea') }}</span>
  </usucampeao-input>

  <div class="radio">
    <ion-label class="description-text description-text--medium">
      Possui imóvel construído no terreno?*
    </ion-label>
    <ion-item class="ion-no-padding" mode="md" lines="none">
      <ion-radio-group formControlName="situation">
        <ion-item class="ion-no-padding" lines="none">
          <ion-radio color="secondary" [value]="imovelSituacao.BUILT" class="ion-margin-end"></ion-radio>
          <ion-label class="ion-text-wrap">Sim</ion-label>
        </ion-item>
        <ion-item class="ion-no-padding" lines="none">
          <ion-radio color="secondary" [value]="imovelSituacao.NO_BUILDING" class="ion-margin-end"></ion-radio>
          <ion-label class="ion-text-wrap">Não</ion-label>
        </ion-item>
        <ion-item class="ion-no-padding" lines="none">
          <ion-radio color="secondary" [value]="imovelSituacao.UNDER_CONSTRUCTION" class="ion-margin-end"></ion-radio>
          <ion-label class="ion-text-wrap">Em construção</ion-label>
        </ion-item>
      </ion-radio-group>
    </ion-item>
    <span class="form-message-error form-message-error--radio-button">{{ gerarMensagemErro('situation') }}</span>
  </div>

  <div class="radio">
    <ion-label class="description-text description-text--medium">
      Possui outra propriedade no bairro?*
    </ion-label>
    <ion-item class="ion-no-padding" mode="md" lines="none">
      <ion-radio-group formControlName="possuiOutroImovel">
        <ion-item class="ion-no-padding" lines="none">
          <ion-radio color="secondary" [value]="true" class="ion-margin-end"></ion-radio>
          <ion-label>Sim</ion-label>
        </ion-item>
        <ion-item class="ion-no-padding" lines="none">
          <ion-radio color="secondary" [value]="false" class="ion-margin-end"></ion-radio>
          <ion-label>Não</ion-label>
        </ion-item>
      </ion-radio-group>
    </ion-item>
    <span class="form-message-error form-message-error--radio-button">{{ gerarMensagemErro('possuiOutroImovel') }}</span>
  </div>
</form>
